window.openPopUp = function(key) {
  const thisPopUp = document.querySelector(`#${key}`);
  if(thisPopUp) {
    thisPopUp.classList.add('is-visible');
    toggleScroll('disable');
  }
}

function closePopUp() {
  const activePopUp = document.querySelector('.popup.is-visible');
  activePopUp.classList.remove('is-visible');
  toggleScroll('enable');
}

const popupBtn = document.querySelectorAll('.js-popup');
if (popupBtn) {
  popupBtn.forEach(btn => btn.addEventListener('click', ()=> {
    event.preventDefault();
    const thisPopUp = event.target.getAttribute('data-popup');
    openPopUp(thisPopUp);
  }));
}

const closeButtons = document.querySelectorAll('.popup__close');
if (closeButtons) {
  closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', ()=> {
    event.preventDefault();
    closePopUp();
  }));
}

const confirmButton = document.querySelector('.popup__confirm');
if (confirmButton) {
  confirmButton.addEventListener('click', ()=> {
    closePopUp();
  });
}

const popupBackdrops = document.querySelectorAll('.popup__backdrop');
if (popupBackdrops) {
  popupBackdrops.forEach(backdrop => backdrop.addEventListener('click', ()=> {
    closePopUp();
  }));
}



// WEBPACK FOOTER //
// ./scripts/util/popUp.js